import { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";

const points = [
  { text: "20+ Years of Combined Intelligence", accent: "#00E5FF" },
  { text: "100+ Engineers. Collective Firepower.", accent: "#FF2D9A" },
  { text: "150+ Clients. Zero Noise. Just Results.", accent: "#00E5FF" },
  { text: "200+ Systems Built & Deployed", accent: "#7A5CFF" },
];

const easeOut = [0.22, 1, 0.36, 1];

export default function WhyDevamind() {
  const [scrollLit, setScrollLit] = useState(new Set());
  const pointRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        setScrollLit((prev) => {
          const next = new Set(prev);
          entries.forEach((e) => {
            const idx = Number(e.target.dataset.idx);
            if (e.isIntersecting) next.add(idx);
            else next.delete(idx);
          });
          return next;
        });
      },
      { rootMargin: "-35% 0px -35% 0px" }
    );
    pointRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return (
    <section data-testid="why-section" className="relative py-32 md:py-48">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2 }}
          className="sys-label mb-16 md:mb-24"
        >
          SYS.ADVANTAGE //
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-y-16 md:gap-x-24">
          {points.map((point, i) => (
            <motion.div
              key={point.text}
              ref={(el) => (pointRefs.current[i] = el)}
              data-idx={i}
              data-testid={`why-point-${i}`}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1, delay: i * 0.12, ease: easeOut }}
              className="group flex justify-center md:justify-start"
            >
              <div className="flex items-center gap-4">
                <div
                  className="w-1 h-8 rounded-full transition-all duration-700"
                  style={{
                    backgroundColor: point.accent,
                    opacity: scrollLit.has(i) ? 0.8 : 0.2,
                    height: scrollLit.has(i) ? "40px" : "32px",
                    boxShadow: scrollLit.has(i) ? `0 0 12px ${point.accent}40` : "none",
                  }}
                />
                <h3
                  className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extralight tracking-tight transition-colors duration-700 pop-click"
                  style={{
                    color: scrollLit.has(i) ? "rgba(255,255,255,0.95)" : "rgba(255,255,255,0.5)",
                  }}
                >
                  {point.text}
                </h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
